import { render, staticRenderFns } from "./IOSystemDialogView.vue?vue&type=template&id=2472876f&"
import script from "./IOSystemDialogView.vue?vue&type=script&lang=ts&"
export * from "./IOSystemDialogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports